function cleanText(value) {
  return typeof value === "string" ? value.trim() : "";
}

export function validateClientProfileForm(form) {
  const errors = {};
  const firstName = cleanText(form?.firstName);
  const lastName = cleanText(form?.lastName);
  const phone = cleanText(form?.phone).replace(/[\s-]/g, "");
  const countyId = cleanText(String(form?.county?.id || ""));
  const cityId = cleanText(String(form?.city?.id || ""));

  if (!firstName) errors.firstName = "required";
  if (!lastName) errors.lastName = "required";
  if (phone && !/^\+?\d{7,13}$/.test(phone)) errors.phone = "phone";
  if (countyId && !cityId) errors.city = "required";

  return errors;
}

export function buildClientProfilePayload(form, languageIref) {
  const preferences = form?.preferences || {};
  const cityId = cleanText(String(form?.city?.id || ""));

  return {
    first_name: cleanText(form?.firstName).slice(0, 128),
    last_name: cleanText(form?.lastName).slice(0, 128),
    ...(cleanText(String(languageIref || ""))
      ? { language: cleanText(String(languageIref)) }
      : {}),
    person: {
      phone: cleanText(form?.phone).slice(0, 32),
      ...(cityId
        ? {
            address: {
              city: { iref: cityId },
            },
          }
        : {}),
    },
    agreeementMarketing: Boolean(preferences.marketing),
    commEmail: Boolean(preferences.email),
    commPhone: Boolean(preferences.phone),
    commSMS: Boolean(preferences.sms),
    commSubjPromo: Boolean(preferences.promotions),
    commSubjNews: Boolean(preferences.news),
    notifOrders: Boolean(preferences.orderNotifications),
    notifPromo: Boolean(preferences.promotionNotifications),
    notifNews: Boolean(preferences.newsNotifications),
    notifRewards: Boolean(preferences.rewardNotifications),
  };
}
